import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

const { spacing } = tokens;

export const list = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.m};
  width: 100%;
`;

export const ctas = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.m};
`;

export const expanderButton = css`
  margin-top: ${spacing.m};
`;
